/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.StripeCouponBean = factory(root.BpmbuildDevelopmentappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The StripeCouponBean model module.
   * @module model/StripeCouponBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeCouponBean</code>.
   * @alias module:model/StripeCouponBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeCouponBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeCouponBean} obj Optional instance to populate.
   * @return {module:model/StripeCouponBean} The populated <code>StripeCouponBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('amount_off'))
        obj.amountOff = ApiClient.convertToType(data['amount_off'], 'Number');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('duration'))
        obj.duration = ApiClient.convertToType(data['duration'], 'String');
      if (data.hasOwnProperty('duration_in_months'))
        obj.durationInMonths = ApiClient.convertToType(data['duration_in_months'], 'Number');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('livemode'))
        obj.livemode = ApiClient.convertToType(data['livemode'], 'Boolean');
      if (data.hasOwnProperty('max_redemptions'))
        obj.maxRedemptions = ApiClient.convertToType(data['max_redemptions'], 'String');
      if (data.hasOwnProperty('metaData'))
        obj.metaData = ApiClient.convertToType(data['metaData'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('object'))
        obj._object = ApiClient.convertToType(data['object'], 'String');
      if (data.hasOwnProperty('percentOff'))
        obj.percentOff = ApiClient.convertToType(data['percentOff'], 'String');
      if (data.hasOwnProperty('redeemBy'))
        obj.redeemBy = ApiClient.convertToType(data['redeemBy'], 'Date');
      if (data.hasOwnProperty('stripeCouponId'))
        obj.stripeCouponId = ApiClient.convertToType(data['stripeCouponId'], 'String');
      if (data.hasOwnProperty('times_redemed'))
        obj.timesRedemed = ApiClient.convertToType(data['times_redemed'], 'Number');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('valid'))
        obj.valid = ApiClient.convertToType(data['valid'], 'Boolean');
    }
    return obj;
  }

  /**
   * @member {Number} amountOff
   */
  exports.prototype.amountOff = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} duration
   */
  exports.prototype.duration = undefined;

  /**
   * @member {Number} durationInMonths
   */
  exports.prototype.durationInMonths = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Boolean} livemode
   */
  exports.prototype.livemode = undefined;

  /**
   * @member {String} maxRedemptions
   */
  exports.prototype.maxRedemptions = undefined;

  /**
   * @member {String} metaData
   */
  exports.prototype.metaData = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} _object
   */
  exports.prototype._object = undefined;

  /**
   * @member {String} percentOff
   */
  exports.prototype.percentOff = undefined;

  /**
   * @member {Date} redeemBy
   */
  exports.prototype.redeemBy = undefined;

  /**
   * @member {String} stripeCouponId
   */
  exports.prototype.stripeCouponId = undefined;

  /**
   * @member {Number} timesRedemed
   */
  exports.prototype.timesRedemed = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {Boolean} valid
   */
  exports.prototype.valid = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/StripeCouponBean.js